<div class="container-fluid customers-root">
  <app-card-analytics
    [stats]="stats"
    [reset]="reset"
    (shareFilterValue)="onFilterBy($event)"
  ></app-card-analytics>

  <div class="table-root">
    <div class="d-flex justify-content-start switch-toggle transparent">
      <!-- <a
        class="separated-toggle-item"
        [ngClass]="currentTab == 4 ? 'active' : ''"
        (click)="changeTab(4); reset = !reset"
        ><div>
          <span class="bubble">{{ countAssigned | number }}</span>
          {{ "COMMON.ASSET_STATUS.ASSIGNED" | translate }}
        </div></a
      > -->
      <a
        class="separated-toggle-item"
        [ngClass]="currentTab == 1 ? 'active' : ''"
        (click)="changeTab(1); reset = !reset"
        ><div>
          <span class="bubble">{{ countSubmited | number }}</span>
          {{ "COMMON.ASSET_STATUS.SUBMITTED" | translate }}
        </div></a
      >
      <!-- <a
        class="separated-toggle-item"
        [ngClass]="currentTab == 2 ? 'active' : ''"
        (click)="changeTab(2); reset = !reset"
        ><div>
          <span class="bubble">{{ countApproved | number }}</span>
          {{ "COMMON.ASSET_STATUS.APPROVED" | translate }}
        </div></a
      > -->
      <!-- <a
        class="separated-toggle-item"
        [ngClass]="currentTab == 3 ? 'active' : ''"
        (click)="changeTab(3); reset = !reset"
        ><div>
          <span class="bubble">{{ countRejected | number }}</span>
          {{ "COMMON.ASSET_STATUS.REJECTED" | translate }}
        </div></a
      > -->
    </div>
    <div class="table-root-child">
      <div
        class="table-action-wrapper d-flex align-items-center justify-content-between"
      >
        <div id="mv_search" class="search-input">
          <img
            src="../../assets/icons/search.svg"
            alt="Search icon"
            (click)="search()"
          />
          <input
            type="text"
            [placeholder]="'COMMON.SEARCH' | translate"
            [(ngModel)]="searchText"
            (keydown.enter)="search()"
            (ngModelChange)="this.searchTextUpdate.next($event)"
          />
        </div>

        <div class="ml-auto d-flex">
          <div>
            <div class="d-flex">
              <div
                id="mv_date-from"
                class="datepicker-container"
                style="width: 24rem"
              >
                <label for="dateFrom"> {{ "COMMON.FROM" | translate }}: </label>
                <input
                  type="date"
                  id="dateFrom"
                  name="dateFrom"
                  [ngClass]="
                    dateFrom > dateTo
                      ? 'btn datepicker-icon-error'
                      : 'btn datepicker-icon'
                  "
                  [(ngModel)]="dateFrom"
                  (change)="datesValid() == true && search()"
                />
              </div>

              <div id="mv_date-to" class="datepicker-container">
                <label for="dateTo" class="right-label">
                  {{ "COMMON.TO" | translate }}:
                </label>
                <input
                  type="date"
                  id="dateTo"
                  name="dateTo"
                  [ngClass]="
                    dateFrom > dateTo
                      ? 'btn datepicker-icon-error'
                      : 'btn datepicker-icon'
                  "
                  [(ngModel)]="dateTo"
                  (change)="datesValid() == true && search()"
                />
              </div>
            </div>
          </div>
          <div
            id="mv_sort-by"
            class="sort-by-root"
            (click)="showSortBy = !showSortBy"
            click-stop-propagation
          >
            <div class="dropdown">
              <span>{{ "COMMON.SORT_BY.TITLE" | translate }}:</span>
              <span>{{ sortByName | translate }}</span>
              <span
                ><img
                  src="../../assets/icons/gray-arrow-down.svg"
                  alt="Gray arrow down"
              /></span>
            </div>
            <div class="dropdown-opened" *ngIf="showSortBy">
              <div
                id="mv_sort-by-newest"
                (click)="sortBy(sortByOptions.NEWEST)"
              >
                {{ "COMMON.SORT_BY.NEWEST" | translate }}
              </div>
              <div
                id="mv_sort-by-oldest"
                (click)="sortBy(sortByOptions.OLDEST)"
              >
                {{ "COMMON.SORT_BY.OLDEST" | translate }}
              </div>
            </div>
          </div>
          <button
            *ngIf="currentTab != 4"
            class="btn btn-icon"
            (click)="download()"
          >
            <span>{{ "COMMON.DOWNLOAD" | translate }}</span>
          </button>
        </div>
      </div>

      <div class="filter">
        <div class="filter-list">
          {{ "COMMON.FILTER" | translate }}
          <app-multi-select-dropdown
            class="multiselect"
            id="mv_region_filter"
            [clicked]="clicked"
            [items]="hasCimDataIntegration ? geographicalRegions : regions"
            [label]="'COMMON.METER_VALIDATION_REGIONS'"
            [showMore]="false"
            [requireApply]="true"
            (shareIndividualCheckedList)="hasCimDataIntegration ? selectGeographicalRegion($event) : selectRegion($event)"
            (applyFilterEmitter)="reloadTable(1)"
          >
          </app-multi-select-dropdown>
          <app-multi-select-dropdown
            class="multiselect"
            id="mv_area_filter"
            [clicked]="clicked"
            [items]="hasCimDataIntegration ? subGeographicalRegions : areas"
            [label]="'COMMON.METER_VALIDATION_AREAS'"
            [showMore]="false"
            [requireApply]="true"
            (shareIndividualCheckedList)="hasCimDataIntegration ? selectSubGeographicalRegion($event) : selectArea($event)"
            (applyFilterEmitter)="reloadTable(1)"
          >
          </app-multi-select-dropdown>
          <select
            id="meter-validations_customer-phase_filter"
            name="phase-select"
            (change)="selectCustomerPhase($event)"
            class="form-select"
          >
            <option value="0" [selected]="customerPhase == -1" disabled>
              {{ "COMMON.METER_VALIDATION_PHASE" | translate }}
            </option>
            <option
              [id]="'meter-validations_customer-phase_filter-' + (i + 1)"
              [selected]="customerPhase == o.value"
              *ngFor="let o of customerPhaseOptions; let i = index"
              value="{{ o.value }}"
            >
              {{ o.translation | translate }}
            </option>
          </select>
          <select
            id="meter-validations_address-validation_filter"
            name="address-validation-select"
            (change)="selectAddressValidation($event)"
            class="form-select"
          >
            <option value="0" [selected]="addressValidation == -1" disabled>
              {{ "METER_VALIDATION.VALIDATION.ADDRESS_VALIDATION" | translate }}
            </option>
            <option
              [id]="'meter-validations_address-validation_filter-' + (i + 1)"
              [selected]="addressValidation == o.value"
              *ngFor="let o of addressAndDtValidations; let i = index"
              value="{{ o.value }}"
            >
              {{ o.translation | translate }}
            </option>
          </select>
          <select
            id="meter-validations_dt-validation_filter"
            name="dt-validation-select"
            (change)="selectDtValidation($event)"
            class="form-select"
          >
            <option value="0" [selected]="dtValidation == -1" disabled>
              {{ "METER_VALIDATION.VALIDATION.DT_VALIDATION" | translate }}
            </option>
            <option
              [id]="'meter-validations_dt-validation_filter-' + (i + 1)"
              [selected]="dtValidation == o.value"
              *ngFor="let o of addressAndDtValidations; let i = index"
              value="{{ o.value }}"
            >
              {{ o.translation | translate }}
            </option>
          </select>
        </div>
        <div *ngIf="selectedFilters.length > 0">
          <app-filter-checklist
            [filters]="selectedFilters"
            (resetFilterEmitter)="resetFilter($event)"
            (removeFilterEmitter)="removeFilter($event)"
            (applyFilterEmitter)="reloadTable(1)"
            [useApply]="true"
          >
          </app-filter-checklist>
        </div>
      </div>
      <div class="table">
        <div *ngIf="mvs">
          <table class="table border-bottom">
            <thead class="table-light">
              <tr>
                <th id="mv_table_header_checkbox">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [checked]="isAllCheckBoxChecked()"
                    (change)="checkAllCheckBox($event)"
                  />
                </th>
                <th id="mv_table_header_acc-no">
                  {{ "COMMON.MBC_DETAILS.ACCOUNT_NO" | translate }}
                </th>
                <th id="mv_table_header_building-owner">
                  {{ "COMMON.TABLE_HEADERS.CUSTOMER_NAME" | translate }}
                </th>
                <th id="mv_table_header_address">
                  {{ "COMMON.ADDRESS" | translate }}
                </th>
                <th id="mv_table_header_region">
                  {{ "COMMON.METER_VALIDATION_REGION" | translate }}
                </th>
                <th id="mv_table_header_district">
                  {{ "COMMON.METER_VALIDATION_AREA" | translate }}
                </th>
                <th id="mv_table_header_feeder">
                  {{ "COMMON.FEEDER" | translate }}
                </th>
                <th id="mv_table_header_dt">
                  {{ "TRANSFORMERS.DT" | translate }}
                </th>
                <th id="mv_table_header_meter-number">
                  {{ "COMMON.MBC_DETAILS.METER_NO" | translate }}
                </th>
                <th id="mv_table_header_meter-number">
                  {{ "COMMON.METER_VALIDATION_PHASE" | translate }}
                </th>
                <th id="mv_table_header_meter-number" *ngIf="currentTab == 4">
                  {{ "COMMON.DATE_TYPE.ASSIGNED_DATE" | translate }}
                </th>
                <th id="mv_table_header_meter-number" *ngIf="currentTab != 4">
                  {{ "COMMON.DATE_TYPE.SUBMITTED_DATE" | translate }}
                </th>
                <th id="mv_table_header_assigned">
                  {{ "COMMON.MBC_DETAILS.ASSIGNED" | translate }}
                </th>
                <th id="mv_table_header_validated-by" *ngIf="currentTab == 1">
                  {{ "COMMON.TABLE_HEADERS.SUBMITTED_BY" | translate }}
                </th>
                <th
                  id="mv_table_header_validated-by"
                  *ngIf="currentTab == 3 || currentTab == 2"
                >
                  {{ "COMMON.TABLE_HEADERS.VALIDATED_BY" | translate }}
                </th>

                <th id="mv_table_header_current-status">
                  {{ "COMMON.TABLE_HEADERS.CURRENT_STATUS" | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                [id]="'mv_table_row-' + (i + 1)"
                *ngFor="let mv of mvs; let i = index"
              >
                <td [id]="'mv_table_checkbox-' + (i + 1)">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    value="{{ mv.id }}"
                  />
                </td>
                <td
                  [id]="'mv_table_acc-no-' + (i + 1)"
                  [routerLink]="['details', mv.meterId]"
                >
                  {{ mv.accountNumber | hasValue }}
                </td>
                <td
                  [id]="'mv_table_acc-name-' + (i + 1)"
                  [routerLink]="['details', mv.meterId]"
                >
                  {{ mv.customerName | hasValue }}
                </td>
                <td
                  [id]="'mv_table_address-' + (i + 1)"
                  [routerLink]="['details', mv.meterId]"
                >
                  {{ mv.address | hasValue }}
                </td>
                <td
                  [id]="'mv_table_region-' + (i + 1)"
                  [routerLink]="['details', mv.meterId]"
                >
                  {{ (hasCimDataIntegration ? mv.geoRegion : mv.region) | hasValue }}
                </td>
                <td
                  [id]="'mv_table_district-' + (i + 1)"
                  [routerLink]="['details', mv.meterId]"
                >
                  {{ (hasCimDataIntegration ? mv.subGeoRegion : mv.district) | hasValue }}
                </td>
                <td
                  [id]="'mv_table_feeder-' + (i + 1)"
                  [routerLink]="['details', mv.meterId]"
                >
                  {{ (hasCimDataIntegration ? mv.acLineName : mv.feederName) | hasValue }}
                </td>
                <td
                  [id]="'mv_table_dt-' + (i + 1)"
                  [routerLink]="['details', mv.meterId]"
                >
                  {{ (hasCimDataIntegration ? mv.substationName : mv.dtName) | hasValue }}
                </td>
                <td
                  [id]="'mv_table_meter-number-' + (i + 1)"
                  [routerLink]="['details', mv.meterId]"
                >
                  {{ mv.meterNumber | hasValue }}
                </td>

                <td
                  [id]="'mv_table_customer-phase-' + (i + 1)"
                  [routerLink]="['details', mv.meterId]"
                >
                  {{ mv.customerPhase | hasValue }}
                </td>
                <td
                  *ngIf="currentTab == 4"
                  [id]="'mv_table_submitted-date-' + (i + 1)"
                  [routerLink]="['details', mv.id]"
                >
                  {{ mv.assignedDate | hasValue }}
                </td>
                <td
                  *ngIf="currentTab != 4"
                  [id]="'mv_table_submitted-date-' + (i + 1)"
                  [routerLink]="['details', mv.meterId]"
                >
                  {{ mv.submittedDate | hasValue }}
                </td>
                <td
                  [id]="'mv_table_assigned-' + (i + 1)"
                  [routerLink]="['details', mv.meterId]"
                >
                  {{ mv.assignedUser | hasValue }}
                </td>
                <td
                  [id]="'mv_table_rejected-date-' + (i + 1)"
                  [routerLink]="['details', mv.meterId]"
                  *ngIf="currentTab == 1"
                >
                  {{ mv.submittedBy | hasValue }}
                </td>
                <td
                  [id]="'mv_table_approved-date-' + (i + 1)"
                  [routerLink]="['details', mv.meterId]"
                  *ngIf="currentTab == 2 || currentTab == 3"
                >
                  {{ mv.validatedBy | hasValue }}
                </td>

                <td
                  [id]="'mv_table_current-status-' + (i + 1)"
                  [routerLink]="['details', mv.meterId]"
                >
                  <div
                    *ngIf="mv.currentStatus"
                    class="building-status"
                    [ngClass]="{
                      'assigned-building': mv.currentStatus == 'Assigned',
                      'rejected-building': mv.currentStatus == 'Rejected',
                      'approved-building': mv.currentStatus == 'Approved',
                      'submitted-building': mv.currentStatus == 'Submitted',
                      'pending-building': mv.currentStatus == 'Pending'
                    }"
                  >
                    {{
                      mv.currentStatus == "Pending"
                        ? "In progress"
                        : mv.currentStatus
                    }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <app-paging
              *ngIf="count > 0"
              [pageSize]="pageSize"
              [count]="count"
              [currentPage]="currentPage"
              [useDirect]="true"
              (pageChange)="pageChange($event)"
            ></app-paging>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
